// eslint-disable-next-line import/no-namespace
import * as React from 'react';
import { Slider as SliderPrimitive } from 'radix-ui';
import { cn } from './helpers';

function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const _values = React.useMemo(
    () =>
      Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
          ? defaultValue
          : [min, max],
    [value, defaultValue, min, max]
  );

  return (
    <SliderPrimitive.Root
      data-slot='slider'
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        'relative flex w-full h-5 touch-none items-center select-none data-disabled:opacity-50 data-vertical:min-h-40 data-vertical:h-full data-vertical:w-auto data-vertical:flex-col',
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot='slider-track'
        className='relative grow overflow-hidden rounded-full bg-primary-200 h-1.5 data-vertical:w-1 data-vertical:h-full data-horizontal:w-full'
      >
        <SliderPrimitive.Range
          data-slot='slider-range'
          className='absolute h-full select-none bg-primary-1000 data-vertical:w-full'
        />
      </SliderPrimitive.Track>
      {Array.from({ length: _values.length }, (_, index) => (
        <SliderPrimitive.Thumb
          data-slot='slider-thumb'
          key={index}
          className='relative block size-4 shrink-0 select-none rounded-full ring-ring/20 border-2 border-primary-900 bg-white transition-[color,box-shadow] hover:ring-3 focus-visible:outline-hidden focus-visible:ring-3 active:ring-3 disabled:pointer-events-none disabled:opacity-50'
        />
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider };
